/* jshint esnext: true */
/**
 * newArrival
 ***********************/
new Vue({
  el: '#newArrival',
  template: '#newArrival-template',

  data: {
    settings: {
      sliceParPc: 12,
      sliceParMobile: 2,
      breakpoint: 992,
      urlPrefixesPath: "./data/new-arrival-prefixes.json",
      jsonPath: './data/new-arrival.json',
    },
    slicePar: null,
    slick: null,
    isMobile: null,
    prefixied: [],
    raw: []
  },

  computed: {
    // rawを[[],[],[]]の形に整形
    arranged: function() {
      let dist = [[]];

      this.prefixied.forEach((el, idx) => {
        let tail = dist.length - 1;

        dist[tail].push(el);

        // not last raw element
        if (this.prefixied.length - 1 === idx) return;
        // slicePar full
        if (dist[tail].length === this.slicePar) dist.push([]);
      });

      return dist;
    },
  },

  methods: {
    handleResize: function() {
      // 1
      this.isMobile = this.getIsMobile();
      // 2
      this.slicePar = this.getSlicePar();
    },
    getSlicePar: function() {
      if (this.isMobile)
        return this.settings.sliceParMobile;
      return this.settings.sliceParPc;
    },
    getIsMobile: function() {
      if (window.innerWidth < this.settings.breakpoint)
        return true;
      return false;
    },
    initJquery: function() {
      if (this.slick) $(this.slick).slick('slickRemove');

      this.slick = $('#newArrivalCarousel').slick({
        mobileFirst: true,
        slidesToShow: 1,
        dots: true,
        autoplay: false,
        arrows: false,
        responsive: [
          {
            breakpoint: this.settings.breakpoint,
            settings: {
              fade: true,
              arrows: true,
              autoplaySpeed: 3000
            }
          }
        ]
      });
    }
  },

  created: function() {
    let _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(data => {
      this.raw = data.slice(0, (12*3));
    }).done(() => {
      setPrefix();
    });

    function setPrefix() {
      $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, el => {
          el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          el.number = urlPrefixes.number_before + el.number + urlPrefixes.number_after;
          return el;
        });
      });
    }
  },

  ready: function() {
    // regist resize handler
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    // watch dom change
    this.$watch('arranged', (newVal, oldVal) => {
      // $nextTick to waiting for created dom
      this.$nextTick(() => {
        this.initJquery();
      });
    });
  }
});
